const key = "proxy-datetime";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/[0-9]*$/);
};

const modify = (resp) => {
	resp.data.Data = {
		...resp.data.Data,
		Schema: {
			...resp.data.Data.Schema,
			properties: {
				...resp.data.Data.Schema.properties,
				dateValue: {
					format: "date",
					title: "Date Test",
					type: "date",
					valueTime: "end"
				}
			}
		}
	};

	return resp;
};

export const addProxyDatetime = [key, applicable, modify];